export const Endpoint = () => `/api/v4/bulletin/get-ai-insight/`;
export const QueryKey = (payload: Payload | undefined) =>
    ['v4', 'bulletins', 'get-ai-insight', payload].filter(Boolean);
export type Payload = { id: string };
export type Response = {
    insight: string;
};
